export class TierDM {
  constructor({
    min_points = 0,
    max_points = 0,
    multiply = 1.0,
    tier_name = "",
    img = "",
    min_point_label = "",
    max_point_label = "",
  }) {
    this.min_points = min_points;
    this.max_points = max_points;
    this.multiply = multiply;
    this.tier_name = tier_name;
    this.img = img;
    this.min_point_label = min_point_label;
    this.max_point_label = max_point_label;
  }

  toJson() {
    return {
      min_points: this.min_points,
      max_points: this.max_points,
      multiply: this.multiply,
      tier_name: this.tier_name,
      img: this.img,
      min_points_label: this.min_point_label,
      max_points_label: this.max_point_label,
    };
  }

  static fromJson(json) {
    return new TierDM({
      min_points: json["min_points"],
      max_points: json["max_points"],
      multiply: json["multiply"],
      tier_name: json["tier_name"],
      img: json["img"],
      min_point_label: json["min_points_label"],
      max_point_label: json["max_points_label"],
    });
  }
}
